import '../App.css';
function VideoPlayer(props){
    return(
        <video key={props.key} id={props.id} width="640" height="480" controls>
            <source src={props.value} type="video/mp4" />
        </video>
    );
}

export default VideoPlayer;